import { type SxProps, type Theme, Typography } from '@mui/material';

type TitleBoxProps = {
  children: React.ReactNode;
  sx?: SxProps<Theme> | SxProps | null;
};

export const TitleBoxTypography = ({ children, sx = {} }: TitleBoxProps) => {
  return (
    <Typography
      variant='h3'
      fontFamily='Inter'
      fontWeight='500'
      fontSize='2.5rem'
      padding='0.2rem 0.5rem'
      sx={sx}
    >
      {children}
    </Typography>
  );
};
